import { cameraStore } from "camera/store/camera";

export const stopFaceIfrunning = (jid: string) => {
  const { activeFaceJid, setActiveFaceJid } = cameraStore();
  if (activeFaceJid === jid) setActiveFaceJid(null);
};
